/**
 * Generated by orval v6.23.0 🍺
 * Do not edit manually.
 * APIs for RCI FE
 * This document describes the APIs provided by NeoAP BE for RCI FE, designed to be integrated into NeoAP FE using `iframe`.\
These APIs utilize cookie-based authentication. All API requests must include the cookie `_ap_session`.

 * OpenAPI spec version: 1
 */
import {
  useInfiniteQuery,
  useQuery,
  useSuspenseInfiniteQuery,
  useSuspenseQuery,
} from '@tanstack/react-query';
import type {
  InfiniteData,
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import type { BadRequestResponse } from '../model/badRequestResponse';
import type { ForbiddenResponse } from '../model/forbiddenResponse';
import type { GetProjectsParams } from '../model/getProjectsParams';
import type { GetProjectsResponse } from '../model/getProjectsResponse';
import type { NotFoundResponse } from '../model/notFoundResponse';
import type { UnauthorizedResponse } from '../model/unauthorizedResponse';
import type { UnprocessableEntityResponse } from '../model/unprocessableEntityResponse';
import { useCustomClient } from '../../mutator/custom-instance';
import type { ErrorType } from '../../mutator/custom-instance';
import { customFomDataFn } from '../../api/formData/custom-function';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P
) => any
  ? P
  : never;

/**
 * @summary Get a list of projects
 */
export const useGetProjectsHook = () => {
  const getProjects = useCustomClient<GetProjectsResponse>();

  return (
    params?: GetProjectsParams,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>
  ) => {
    return getProjects(
      { url: `/api/js/projects`, method: 'GET', params },
      options
    );
  };
};

export const getGetProjectsQueryKey = (params?: GetProjectsParams) => {
  return [`/api/js/projects`, ...(params ? [params] : [])] as const;
};

export const useGetProjectsInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<ReturnType<typeof useGetProjectsHook>>>,
    GetProjectsParams['cursor']
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  params?: GetProjectsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetProjectsHook>>>,
        TError,
        TData,
        Awaited<ReturnType<ReturnType<typeof useGetProjectsHook>>>,
        QueryKey,
        GetProjectsParams['cursor']
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProjectsQueryKey(params);

  const getProjects = useGetProjectsHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetProjectsHook>>>,
    QueryKey,
    GetProjectsParams['cursor']
  > = ({ pageParam }) =>
    getProjects(
      { ...params, cursor: pageParam || params?.['cursor'] },
      requestOptions
    );

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetProjectsHook>>>,
    TError,
    TData,
    Awaited<ReturnType<ReturnType<typeof useGetProjectsHook>>>,
    QueryKey,
    GetProjectsParams['cursor']
  > & { queryKey: QueryKey };
};

export type GetProjectsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetProjectsHook>>>
>;
export type GetProjectsInfiniteQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Get a list of projects
 */
export const useGetProjectsInfinite = <
  TData = InfiniteData<
    Awaited<ReturnType<ReturnType<typeof useGetProjectsHook>>>,
    GetProjectsParams['cursor']
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  params?: GetProjectsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetProjectsHook>>>,
        TError,
        TData,
        Awaited<ReturnType<ReturnType<typeof useGetProjectsHook>>>,
        QueryKey,
        GetProjectsParams['cursor']
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetProjectsInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGetProjectsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetProjectsHook>>>,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  params?: GetProjectsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetProjectsHook>>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProjectsQueryKey(params);

  const getProjects = useGetProjectsHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetProjectsHook>>>
  > = () => getProjects(params, requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetProjectsHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetProjectsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetProjectsHook>>>
>;
export type GetProjectsQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Get a list of projects
 */
export const useGetProjects = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetProjectsHook>>>,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  params?: GetProjectsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetProjectsHook>>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetProjectsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGetProjectsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetProjectsHook>>>,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  params?: GetProjectsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetProjectsHook>>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProjectsQueryKey(params);

  const getProjects = useGetProjectsHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetProjectsHook>>>
  > = () => getProjects(params, requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetProjectsHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetProjectsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetProjectsHook>>>
>;
export type GetProjectsSuspenseQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Get a list of projects
 */
export const useGetProjectsSuspense = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetProjectsHook>>>,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  params?: GetProjectsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetProjectsHook>>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetProjectsSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGetProjectsSuspenseInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<ReturnType<typeof useGetProjectsHook>>>,
    GetProjectsParams['cursor']
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  params?: GetProjectsParams,
  options?: {
    query?: Partial<
      UseSuspenseInfiniteQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetProjectsHook>>>,
        TError,
        TData,
        Awaited<ReturnType<ReturnType<typeof useGetProjectsHook>>>,
        QueryKey,
        GetProjectsParams['cursor']
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProjectsQueryKey(params);

  const getProjects = useGetProjectsHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetProjectsHook>>>,
    QueryKey,
    GetProjectsParams['cursor']
  > = ({ pageParam }) =>
    getProjects(
      { ...params, cursor: pageParam || params?.['cursor'] },
      requestOptions
    );

  return {
    queryKey,
    queryFn,
    ...queryOptions,
  } as UseSuspenseInfiniteQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetProjectsHook>>>,
    TError,
    TData,
    Awaited<ReturnType<ReturnType<typeof useGetProjectsHook>>>,
    QueryKey,
    GetProjectsParams['cursor']
  > & { queryKey: QueryKey };
};

export type GetProjectsSuspenseInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetProjectsHook>>>
>;
export type GetProjectsSuspenseInfiniteQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Get a list of projects
 */
export const useGetProjectsSuspenseInfinite = <
  TData = InfiniteData<
    Awaited<ReturnType<ReturnType<typeof useGetProjectsHook>>>,
    GetProjectsParams['cursor']
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  params?: GetProjectsParams,
  options?: {
    query?: Partial<
      UseSuspenseInfiniteQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetProjectsHook>>>,
        TError,
        TData,
        Awaited<ReturnType<ReturnType<typeof useGetProjectsHook>>>,
        QueryKey,
        GetProjectsParams['cursor']
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetProjectsSuspenseInfiniteQueryOptions(
    params,
    options
  );

  const query = useSuspenseInfiniteQuery(
    queryOptions
  ) as UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
